// extracted by mini-css-extract-plugin
export default {"price":"N8-z","onSale":"O8-z","msrpLabelPrice":"P8-z","msrpLabel":"Q8-z","originalPrice":"R8-z","percentOff":"S8-z"};